var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.divWrapper()},[_vm._t("header-link",function(){return [_c('label',[_vm._v(" 門市資訊 "),_c('a',{staticClass:"pull-right",attrs:{"href":"javascript:void(0);"},on:{"click":function($event){return _vm.change()}}},[_vm._v(" 更改 ")])])]}),_c('div',{class:_vm.insideWrapper()},[_c('store-hours',{attrs:{"info":_vm.storeInfo}})],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }